import { ChangeDetectionStrategy, Component, EventEmitter, Output, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@next/core-lib/i18n';

@Component({
  selector: 'app-dairy-yield-scan-cover',
  templateUrl: './dairy-yield-scan-cover.component.html',
  styleUrls: ['./dairy-yield-scan-cover.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButtonModule, MatIconModule, TranslatePipe],
})
export class DairyYieldScanCoverComponent {
  @Output() readonly startScan = new EventEmitter<void>();

  readonly activePage = signal(0);

  nextPage(): void {
    this.activePage.update((page) => Math.min(page + 1, 2));
  }

  previousPage(): void {
    this.activePage.update((page) => Math.max(page - 1, 0));
  }
}
